/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChecklistInstancesDto } from '../models/ChecklistInstancesDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ChecklistInstancesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all compliance items from the DB.
     * @param orgGuid
     * @returns ChecklistInstancesDto OK
     * @throws ApiError
     */
    public getAllChecklistResponses(
        orgGuid: string,
    ): CancelablePromise<Array<ChecklistInstancesDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ChecklistInstances/{orgGuid}/GetAllChecklistResponses',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
